// @ts-nocheck
import React from 'react';

const SvgUpload = props => (
  <svg viewBox="0 0 64 64" {...props}>
    <path
      d="M46.01 44.02h-6a2 2 0 0 1 0-4h5.906a8.058 8.058 0 0 0 8.094-7.927c.038-5.377-4.133-7.226-6.59-8.064a1.992 1.992 0 0 1-1.34-1.703l-.103-1.082a10.106 10.106 0 0 0-9.83-9.222c-4.668-.055-7.12 2.677-8.707 4.683a1.993 1.993 0 0 1-1.993.696 9.816 9.816 0 0 0-2.634-.377 6.005 6.005 0 0 0-5.792 5.871L16.99 24.2c-.016.8-.51 1.512-1.254 1.807-2.593 1.015-5.887 2.659-5.719 7.357a6.97 6.97 0 0 0 6.993 6.658h7a2 2 0 1 1 0 4h-7c-6.072.003-10.997-4.918-11-10.99a10.995 10.995 0 0 1 7.012-10.253c.125-5.512 4.695-9.88 10.207-9.755a9.983 9.983 0 0 1 1.881.223c4.841-6.023 13.648-6.98 19.67-2.138a13.991 13.991 0 0 1 5.163 9.586c6.26 2.169 9.575 9 7.406 15.26A11.994 11.994 0 0 1 46.01 44.02zm-21.814-9.61l6.989-9.975a.996.996 0 0 1 1.638 0l6.989 9.974a1.027 1.027 0 0 1-.82 1.623H34.01V56.02a2 2 0 1 1-4 0V36.03h-4.995a1.027 1.027 0 0 1-.819-1.622z"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgUpload;
